import { useMutation, useQueryClient } from '@tanstack/react-query'
import { RiCloseCircleFill } from 'react-icons/ri'
import { toast } from 'sonner'

import { Button, DialogClose } from '@/_components/ui'
import { Text, Title } from '@/features/_components/ui/typography'
import { mutations } from '@/features/_lib/react-query'

type DeleteUserDialogProps = {
  id: string
  name: string
  companyId: string
  setIsDialogOpen: (isOpen: boolean) => void
}

export const DeleteUserDialog = ({
  id,
  name,
  companyId: _companyId,
  setIsDialogOpen,
}: DeleteUserDialogProps) => {
  const queryClient = useQueryClient()
  const deleteUser = useMutation(mutations.users.delete(queryClient))

  const handleDeleteClick = () => {
    deleteUser.mutate(id, {
      onSuccess: () => {
        setIsDialogOpen(false)
        toast.success('Usuário deletado com sucesso!')
      },
      onError: () => {
        toast.error('Erro ao deletar o usuário')
      },
    })
  }

  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-2">
        <div className="flex items-start gap-1">
          <RiCloseCircleFill
            className="flex-shrink-0 flex-grow-0 basis-6 text-aux-red-danger-6"
            size={24}
          />
          <Title className="text-base">Deseja deletar o usuário {name}?</Title>
        </div>
        <Text>Atenção, o usuário será deletado do sistema! Tem certeza que deseja continuar?</Text>
      </div>
      <div className="flex gap-3 self-end">
        <DialogClose asChild>
          <Button variant="gray" className="rounded-md font-bold">
            Cancelar
          </Button>
        </DialogClose>
        <Button
          variant="destructive"
          className="min-w-[80px] text-sm font-bold"
          onClick={handleDeleteClick}
          disabled={deleteUser.isPending}
        >
          {deleteUser.isPending ? 'Deletando...' : 'Deletar'}
        </Button>
      </div>
    </div>
  )
}
